import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import QuestionView from "@/views/QuestionView";
import Result1View from "@/views/Result1View";
import Result2View from "@/views/Result2View";
import Result3View from "@/views/Result3View";
import Result4View from "@/views/Result4View";
import Result5View from "@/views/Result5View";
import Result6View from "@/views/Result6View";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {path: "/quiz", name: "quiz", component: QuestionView},
  {path: "/result-1", name: "result-1", component: Result1View},
  {path: "/result-2", name: "result-2", component: Result2View},
  {path: "/result-3", name: "result-3", component: Result3View},
  {path: "/result-4", name: "result-4", component: Result4View},
  {path: "/result-5", name: "result-5", component: Result5View},
  {path: "/result-6", name: "result-6", component: Result6View}
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ left: 0, top: 0 })
      }, 500)
    })
  },
})

export default router
